import LogoWhite from "../../assets/logo/logo-white.svg?react";
import { WelcomeFooter } from "../welcome/components/WelcomeFooter";

/**
 * Premium fullscreen layout with gradient background.
 * Used for: subscription success/failure pages, error screens.
 *
 * Replaces legacy BlueWaveLayout.tsx (with blue_wave.mp4 video).
 * Uses bg-gradient-hero-dark from design system for consistent premium aesthetic.
 */
export function PremiumFullscreenLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="relative w-[100dvw] h-[100dvh] overflow-hidden flex flex-col z-50 bg-gradient-hero-dark">
      {/* Logo */}
      <div className="p-5">
        <LogoWhite className="h-[26px] w-[126px]" />
      </div>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center px-6">
        {children}
      </div>

      {/* Footer */}
      <WelcomeFooter />
    </div>
  );
}
